import { isPast, isFuture } from "date-fns";
import data from "../../.sourceflow/events.json";
import CollectionHelper from "@/helpers/CollectionHelper";

import { isBefore, isAfter, isEqual, startOfDay } from "date-fns";

class EventsCollectionHelper extends CollectionHelper {
  search(query, locale = "en") {
    return this.filter((e) =>
      e[`title_${locale}`]
        ?.toLowerCase()
        .includes(query.toLowerCase())
    );
  }

  isPastEvent(event) {
    const today = startOfDay(new Date());
    const eventDate = startOfDay(new Date(event.date));
    return isBefore(eventDate, today); // strictly before today
  }

  isUpcomingEvent(event) {
    const today = startOfDay(new Date());
    const eventDate = startOfDay(new Date(event.date));
    return isAfter(eventDate, today) || isEqual(eventDate, today); // today or future
  }

  matchesTag(e, tag) {
    return tag && "tags" in e ? e.tags.includes(tag) : true;
  }

  fetchUpcomingEvents({ tag = "", query = "", locale = "en" }) {
    return this.search(query, locale)
      .filter((e) => this.matchesTag(e, tag))
      .filter((e) => this.isUpcomingEvent(e))
      .sort((a, b) => new Date(a.date) - new Date(b.date)); // soonest first
  }

  fetchPastEvents({ tag = "", query = "", locale = "en" }) {
    return this.search(query, locale)
      .filter((e) => this.matchesTag(e, tag))
      .filter((e) => this.isPastEvent(e))
      .sort((a, b) => new Date(b.date) - new Date(a.date)); // newest past first
  }

  fetchSimilar(event) {
    const event_tags = Array.isArray(event.tags) ? event.tags : [event.tags];

    return this.fetch({
      limit: 5,
      filter: (e) => {
        const e_tags = Array.isArray(e.tags) ? e.tags : [e.tags];
        return e.id !== event.id && event_tags.some((t) => e_tags.includes(t));
      },
    });
  }

  fetchTags() {
    return data.schema.find((s) => s.name === `Tags`).dropdown_values;
  }
}

export const events_helper = new EventsCollectionHelper(data);

export default EventsCollectionHelper;
